import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
import { LOGO_IMAGE_URL, business } from '../data/business';
import { GoldDivider } from './GoldDivider';
import { HeroEmblem } from './HeroEmblem';
import { PhoneButton } from './PhoneButton';
const ease = [0.23, 1, 0.32, 1] as const;
export function TruckHero() {
  const reduce = useReducedMotion();
  return <section id="top" aria-label="Oh My Tacos food truck" className="w-full overflow-hidden bg-night" data-id="element-107" data-mp="7fmwmrd143cq">
      <div className="wrap pt-[clamp(1.25rem,2.5vh,4rem)]" data-id="element-108" data-mp="c8fzf9oxt1m6">
        <GoldDivider data-id="element-109" data-mp="3uldxfb265kdp" />
      </div>

      <div className="wrap grid grid-cols-1 items-center gap-[clamp(2.5rem,4vw,10rem)] py-[clamp(2.5rem,5vh,8rem)] lg:grid-cols-[1.15fr_0.85fr]" data-id="element-110" data-mp="3umf7pdbd22ud">
        <div className="order-2 min-w-0 lg:order-1" data-id="element-111" data-mp="2f8n14vs4lcl">
          <p className="fs-hero-kicker font-display italic leading-tight text-gold-light" data-id="element-112" data-mp="3ko96kxxdp0qk">¡Bienvenidos a</p>
          <h1 className="fs-hero text-gold-gradient mt-[0.05em] pb-[0.08em] font-display font-bold leading-[1.02]" data-id="element-113" data-mp="3pkzmnl96nwbz">
            Oh My Tacos!
          </h1>
          <p className="fs-hero-body mt-[clamp(0.75rem,2vh,3rem)] max-w-[34em] leading-relaxed text-muted" data-id="element-114" data-mp="1nfcmz45fm9pz">
            {business.tagline}
          </p>

          <div className="fs-hero-meta mt-[clamp(1.25rem,3vh,4rem)] flex flex-col gap-[0.6em]" data-id="element-115" data-mp="21ec1vk357a8y">
            <p className="inline-flex flex-wrap items-center gap-x-[0.55em] gap-y-1 font-label uppercase tracking-[0.14em]" data-id="element-116" data-mp="1wgaggsi8uyub">
              <span className="relative flex h-[0.7em] w-[0.7em]" aria-hidden="true" data-id="element-117" data-mp="18ntyehyib6v0">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-gold opacity-60 motion-reduce:animate-none" data-id="element-118" data-mp="14mi624o907j4" />
                <span className="relative inline-flex h-full w-full rounded-full bg-gold-light" data-id="element-119" data-mp="1dore8nw1notc" />
              </span>
              <span className="text-gold-light" data-id="element-120" data-mp="pyncyn6bw15i">Abierto hoy · Open today</span>
              <span className="text-muted" data-id="element-121" data-mp="l15czmaagw9n">· {business.todayHours}</span>
            </p>
            <p className="inline-flex items-center gap-[0.5em] text-muted" data-id="element-122" data-mp="2l34vtj0g0llb">
              <MapPinIcon className="h-[1.1em] w-[1.1em] text-copper" aria-hidden="true" data-id="element-123" data-mp="2l10v19xuc2p9" />
              {business.todayStop}
            </p>
          </div>

          <div className="mt-[clamp(1.5rem,3.5vh,4.5rem)] flex flex-wrap gap-[clamp(0.75rem,0.9vw,2rem)]" data-id="element-124" data-mp="2utpv78nxxu5a">
            <PhoneButton size="lg" data-id="element-125" data-mp="2zqg9prk3khol" />
            <a href="#menu" className="fs-btn inline-flex items-center whitespace-nowrap rounded-full border border-gold/70 px-[1.75em] py-[1em] font-label font-medium uppercase leading-none tracking-[0.16em] text-gold-light transition-[background-color,border-color] duration-150 ease-out hover:border-gold-light hover:bg-gold/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-night" data-id="element-126" data-mp="2ztkht00onxkj">
              Ver el menú
            </a>
          </div>
        </div>

        <motion.div initial={reduce ? false : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease
      }} className="order-1 flex justify-center lg:order-2 lg:justify-end" data-id="element-127" data-mp="3rh46ysinh2wz">
          <HeroEmblem logoSrc={LOGO_IMAGE_URL || undefined} className="emblem-size" data-id="element-128" data-mp="172gun90eqoh2" />
        </motion.div>
      </div>
    </section>;
}